module.exports = __webpack_public_path__ + "img/exmpl-ui_space-selector.1e16c545.png";